import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import I18n from 'I18n';
import { useGetQueryParam, useGetQueryParamWithArrays } from '../../app/hooks/useGetQueryParam';
import { selectHasNewToYouGate } from '../../app/auth/GateSelectors';
import { useAppSelector } from '../../app/indexReducer';
import { NewToYouContext } from '../components/IndexPage';
export const useRawParamsForListRolloutProductUpdates = () => {
  const {
    category
  } = useParams();
  const hasNewToYouGate = useAppSelector(selectHasNewToYouGate);
  const calendarTimestamp = useGetQueryParam('calendarTimestamp');
  const limit = useGetQueryParam('limit');
  const offset = useGetQueryParam('offset');
  const isFavorite = useGetQueryParam('isFavorite');
  const {
    newToYouTimestamp
  } = useContext(NewToYouContext);
  const startDateFromQuery = useGetQueryParam('startDate');
  return {
    app: useGetQueryParamWithArrays('app'),
    betaStatus: useGetQueryParamWithArrays('betaStatus'),
    calendarTimestamp: calendarTimestamp ? parseInt(calendarTimestamp, 10) : null,
    category: category || null,
    endDate: useGetQueryParam('endDate'),
    impactLevels: useGetQueryParamWithArrays('impactLevels'),
    isFavorite: isFavorite === 'true' || null,
    limit: limit ? parseInt(limit, 10) : null,
    offset: offset ? parseInt(offset, 10) : null,
    product: useGetQueryParamWithArrays('product'),
    query: useGetQueryParam('query'),
    recommended: category === 'recommended' || null,
    rolloutState: useGetQueryParam('rolloutState'),
    startDate: category === 'new-to-you' && hasNewToYouGate ? newToYouTimestamp ? I18n.moment.utc(newToYouTimestamp).format('YYYY-MM-DD') : null : startDateFromQuery,
    type: useGetQueryParam('type'),
    view: useGetQueryParam('view') || null
  };
};